import { TDarkModes } from '../types/darkMode.type';

const DARK_MODE: TDarkModes = {
	DARK: 'dark',
	LIGHT: 'light',
	SYSTEM: 'system',
};

export default DARK_MODE;
